import { PersonalOfferStorageService, RunConfigService} from '@nuskin/ns-util';
import axios from 'axios'

const getPath = () => { 
    const isProd = RunConfigService.getEnvironmentCode() === 'prod'
    return `https://${isProd ? '' : 'test'}api.cloud.nuskin.com/ns-share-api`
}
/**
 * axios wrapper
 * @param {Object} config - required param
 * @param {String} param.method - request method
 * @param {String} param.url - request url
 * @param {String} param.headers - request headers
 * @param {String} param.payload - request payload
 */
let personalOfferHttp = async config => {
    config.method = config.method || 'get'
    config.headers = {
        'client_id': '735b1eb810304bba966af0891ab54053',
        'Content-Type': 'application/json'
    }
    try {
        const response = await axios(config)
 
        return response.data
    } catch (error) {
        const errConfig = error.config || { method: 'unknown', url: 'unknown' }
        const message = `[${errConfig.method.toUpperCase()}] call to '${errConfig.url}' failed in personalOfferService.js: ${error.message} `
        throw new Error(message)
    }
}

const PersonalOfferService = function() {

    let currentStep = 1;
    
    return {
        getPitch: async function(userId, pitchId) {
            let url = `${getPath()}/v0/my-store/user/${userId}/pitch/${pitchId}`
            let data = await personalOfferHttp({url})
            return data.pitch
        },
        getOfferV2: async function(userId, shareLinkId) {
            let url = `${getPath()}/v1/connect/user/${userId}/share-link/${shareLinkId}`
            let data = await personalOfferHttp({url})
            return data.shareLink
        },
        callProduct: async function(sponsorID, pitchID) {

            // v1
            if (currentStep === 1) {
                let localOffer = PersonalOfferStorageService.getPersonalOffer()
                if(localOffer && localOffer.event && !localOffer.event.product) {
                    let url = `${getPath()}/v0/my-store/user/${sponsorID}/pitch/${pitchID}`
                    let data = {"product":new Date().getTime(), "step" : 1}
                    await personalOfferHttp({url, method: 'put', data})
                }
                currentStep = 1;
            }

            // v2
            let status = 'product_added'
            let sessionData = localStorage.getItem('personalOffer_v2') ? JSON.parse(localStorage.getItem('personalOffer_v2')) : null
            let sessionID = sessionData ? sessionData.sessionId : null
            let v2Offer = await PersonalOfferService.getOfferV2(sponsorID, pitchID)
            // if current session and new status
            let currentSessionAndNewStatus = v2Offer.sessions &&
                v2Offer.sessions[sessionID] &&
                v2Offer.sessions[sessionID].status_history &&
                !v2Offer.sessions[sessionID].status_history[status];

            if(sessionID && currentSessionAndNewStatus) {
                let url = `${getPath()}/v1/connect/user/${sponsorID}/share-link/${pitchID}/session/${sessionID}`
                let data = {
                    status
                }
                return personalOfferHttp({url, method: 'put', data})
            }
        },
        callShipping: async function(sponsorID, pitchID) {
            if (currentStep < 2) {
                let url = `${getPath()}/v0/my-store/user/${sponsorID}/pitch/${pitchID}`
                let data = {"shipping":new Date().getTime(), "step" : 2}
                personalOfferHttp({url, method: 'put', data})
                currentStep = 2;
            }
        },
        callDelivery: async function(sponsorID, pitchID) {
            if (currentStep < 3) {
                let url = `${getPath()}/v0/my-store/user/${sponsorID}/pitch/${pitchID}`
                let data = {"delivery":new Date().getTime(), "step" : 3}
                personalOfferHttp({url, method: 'put', data})
                currentStep = 3;
            }
        },
        callPayment: async function(sponsorID, pitchID) {

            if (currentStep < 4) {
                let url = `${getPath()}/v0/my-store/user/${sponsorID}/pitch/${pitchID}`
                let data = {"payment":new Date().getTime(), "step" : 4}
                personalOfferHttp({url, method: 'put', data})
                currentStep = 4;
            }
        },
        callReview: async function(sponsorID, pitchID) {

            if (currentStep < 5) {
                let url = `${getPath()}/v0/my-store/user/${sponsorID}/pitch/${pitchID}`
                let data = {"review":new Date().getTime(), "step" : 5}
                personalOfferHttp({url, method: 'put', data})
                currentStep = 5;
            }
        },
        callComplete: async function(sponsorID, pitchID) {

            // v1
            if (currentStep < 6) {
                let url = `${getPath()}/v0/my-store/user/${sponsorID}/pitch/${pitchID}`
                let data = {"complete":new Date().getTime(), "step" : 6}
                personalOfferHttp({url, method: 'put', data})
                currentStep = 6;
            }
            // v2
            let status = 'purchased'
            let sessionData = localStorage.getItem('personalOffer_v2') ? JSON.parse(localStorage.getItem('personalOffer_v2')) : null
            let sessionID = sessionData ? sessionData.sessionId : null
            let v2Offer = await PersonalOfferService.getOfferV2(sponsorID, pitchID);
            // if current session and new status
            let currentSessionAndNewStatus = v2Offer.sessions &&
                v2Offer.sessions[sessionID] &&
                v2Offer.sessions[sessionID].status_history &&
                !v2Offer.sessions[sessionID].status_history[status];

            if(sessionID && currentSessionAndNewStatus) {
                let url = `${getPath()}/v1/connect/user/${sponsorID}/share-link/${pitchID}/session/${sessionID}`
                let data = {
                    status
                }
                personalOfferHttp({url, method: 'put', data})
                localStorage.removeItem('personalOffer_v2')
            }
        },
        callVeraPurchase: async function (sponsorID) {

            try {
                const status = 'purchased'
                const session = JSON.parse(localStorage.getItem('skinConsult_session') || {})
                let sessionID = session.sessionId
                let linkID = session.linkID
                const veraData = JSON.parse(localStorage.getItem('skin-consultation-vuex-state')) || {}
                if(sessionID && linkID && veraData && veraData.app && veraData.app.agreedToProgressUpdateShare) {
                    let url = `${getPath()}/v1/connect/user/${sponsorID}/share-link/${linkID}/session/${sessionID}`
                    let data = { status }
                    personalOfferHttp({url, method: 'put', data})
                }
            } catch (err) {
                console.log(err)
                console.log('Failed updating VERA status')
            }
        },
        // v2 - sets new session and updates status to 'viewed'
        callViewed: async function(sponsorID, pitchID, v1Data) {
            let url
            let data
            let status = 'viewed'

            if(v1Data) {
                url = `${getPath()}/v0/my-store/user/${sponsorID}/pitch/${pitchID}`
                personalOfferHttp({url, method: 'put', data: v1Data})
            }
            url = `${getPath()}/v1/connect/user/${sponsorID}/share-link/${pitchID}/session`
            data = { status }
            return personalOfferHttp({url, method: 'put', data})
        },
        getCurrentStep: function() {
            return currentStep;
        }
    }
}();



export default PersonalOfferService;
